var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82:239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9755 14.7169H26.5763V10.5249C26.5763 10.2858 26.3824 10.0919 26.1433 10.0919C25.9042 10.0919 25.7104 10.2858 25.7104 10.5249V15.1499C25.7104 15.389 25.9042 15.5828 26.1433 15.5828H34.5425V25.3386H26.1433C25.9042 25.3386 25.7104 25.5325 25.7104 25.7716V34.1708H15.9546V25.7715C15.9546 25.5324 15.7607 25.3386 15.5217 25.3386H12.0656C11.8265 25.3386 11.6326 25.5324 11.6326 25.7715C11.6326 26.0106 11.8265 26.2045 12.0656 26.2045H15.0887V34.6037C15.0887 34.8427 15.2826 35.0366 15.5217 35.0366H26.1434C26.3824 35.0366 26.5763 34.8427 26.5763 34.6037V26.2045H34.9755C35.2146 26.2045 35.4085 26.0106 35.4085 25.7715V15.1499C35.4084 14.9107 35.2145 14.7169 34.9755 14.7169Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1433 5.88477H15.5216C15.2826 5.88477 15.0887 6.07864 15.0887 6.31772V14.7169H6.68948C6.4504 14.7169 6.25653 14.9108 6.25653 15.1499V25.7716C6.25653 26.0106 6.4504 26.2045 6.68948 26.2045H10.6224C10.8614 26.2045 11.0553 26.0106 11.0553 25.7716C11.0553 25.5325 10.8614 25.3386 10.6224 25.3386H7.12243V15.5828H15.5216C15.7607 15.5828 15.9546 15.3889 15.9546 15.1499V6.75067H25.7104V9.08173C25.7104 9.32081 25.9042 9.51468 26.1433 9.51468C26.3824 9.51468 26.5763 9.32081 26.5763 9.08173V6.31772C26.5762 6.07864 26.3824 5.88477 26.1433 5.88477Z",
    fill: "#242731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82:239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.1518,
    height: 29.1518,
    fill: "white",
    transform: "translate(6.25653 5.88477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/Medicine.204320ad1ed45962560999b77af508ac.svg";
export { ForwardRef as ReactComponent };